<ng-template #icon></ng-template>
